import type { AgentKind } from './types';

export interface AgentDefinition {
  kind: AgentKind;
  label: string;
  description: string;
  defaultProvider: string;
  defaultModel: string;
  defaultTools: string[];
  icon: string; // lucide icon name
  cli?: boolean; // true for terminal-CLI-backed agents
}

export const AGENT_REGISTRY: Record<AgentKind, AgentDefinition> = {
  // ----- Terminal-CLI agents (run on the VPS) -----
  claude_cli: {
    kind: 'claude_cli',
    label: 'Claude (CLI)',
    description: 'Claude Code via terminal session on the VPS.',
    defaultProvider: 'claude_cli',
    defaultModel: 'claude_cli',
    defaultTools: [],
    icon: 'Sparkles',
    cli: true,
  },
  codex_cli: {
    kind: 'codex_cli',
    label: 'Codex (CLI)',
    description: 'OpenAI Codex CLI via terminal session.',
    defaultProvider: 'codex_cli',
    defaultModel: 'codex_cli',
    defaultTools: [],
    icon: 'Code2',
    cli: true,
  },
  gemini_cli: {
    kind: 'gemini_cli',
    label: 'Gemini (CLI)',
    description: 'Gemini CLI via terminal session.',
    defaultProvider: 'gemini_cli',
    defaultModel: 'gemini_cli',
    defaultTools: [],
    icon: 'Telescope',
    cli: true,
  },
  hermes: {
    kind: 'hermes',
    label: 'Hermes',
    description: 'Hermes agent via terminal session.',
    defaultProvider: 'hermes',
    defaultModel: 'hermes',
    defaultTools: [],
    icon: 'Wand2',
    cli: true,
  },
  custom_cli: {
    kind: 'custom_cli',
    label: 'Custom CLI',
    description: 'User-configured CLI session.',
    defaultProvider: 'custom_cli',
    defaultModel: 'custom_cli',
    defaultTools: [],
    icon: 'Boxes',
    cli: true,
  },

  // ----- Legacy / UI-affordance kinds (keep for back-compat) -----
  claude: {
    kind: 'claude',
    label: 'Claude (API)',
    description: 'Anthropic Claude via API (CORS-blocked in browser).',
    defaultProvider: 'anthropic',
    defaultModel: 'claude-opus-4-7',
    defaultTools: ['read_file', 'write_file', 'run_command', 'web_search'],
    icon: 'Sparkles',
  },
  codex: {
    kind: 'codex',
    label: 'Codex (API)',
    description: 'Codex via API.',
    defaultProvider: 'openai',
    defaultModel: 'gpt-5',
    defaultTools: ['read_file', 'write_file', 'run_command'],
    icon: 'Code2',
  },
  research: {
    kind: 'research',
    label: 'Research',
    description: 'Multi-step research with web + docs.',
    defaultProvider: 'mock',
    defaultModel: 'mock-default',
    defaultTools: ['web_search', 'read_url', 'read_file'],
    icon: 'Telescope',
  },
  debug: {
    kind: 'debug',
    label: 'Debugging',
    description: 'Reproduce, isolate, and fix bugs in code.',
    defaultProvider: 'mock',
    defaultModel: 'mock-default',
    defaultTools: ['read_file', 'run_command', 'run_tests', 'grep'],
    icon: 'Bug',
  },
  custom: {
    kind: 'custom',
    label: 'Custom',
    description: 'User-configured agent.',
    defaultProvider: 'mock',
    defaultModel: 'mock-default',
    defaultTools: [],
    icon: 'Boxes',
  },
};
